export const SHOW_PRO_ORIENTED_SEARCH_MODAL_INFO = 'pro_search_modal_info';
export const SHOW_PRO_MODAL_DISMISSED_COOKIE_KEY = 'pro_search_modal_info_dismiss';
